module.exports = __webpack_public_path__ + "static/img/kakao-cs.9893e64.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/kakao-cs.jpg
// module id = 9JRC
// module chunks = 0